export default "__VITE_ASSET__DN27Ca6j__"